import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
type CareerGenomeCalculationProps = {
  onComplete: () => void;
};
export const CareerGenomeCalculation: React.FC<CareerGenomeCalculationProps> = ({
  onComplete
}) => {
  const [progress, setProgress] = useState(0);
  const [currentStage, setCurrentStage] = useState(0);
  const stages = ['Analyzing your inborn traits...', 'Mapping your personality patterns...', 'Correlating with context factors...', 'Aligning your stars...', 'Calculating trait affinities...', 'Identifying career DNA matches...', 'Generating your Career Genome...'];
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            onComplete();
          }, 1000);
          return 100;
        }
        return prev + 1;
      });
      // Update stage based on progress
      if (progress < 15) setCurrentStage(0);else if (progress < 30) setCurrentStage(1);else if (progress < 45) setCurrentStage(2);else if (progress < 60) setCurrentStage(3);else if (progress < 75) setCurrentStage(4);else if (progress < 90) setCurrentStage(5);else setCurrentStage(6);
    }, 50);
    return () => clearInterval(timer);
  }, [progress, onComplete]);
  return <div className="min-h-screen w-full bg-gradient-to-b from-[#0A1128] to-[#1C2541] text-white flex items-center justify-center p-4" data-id="element-903">
      <div className="max-w-md w-full text-center" data-id="element-904">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="mb-12" data-id="element-905">
          <div className="relative w-48 h-48 mx-auto mb-8" data-id="element-906">
            {/* Outer ring */}
            <svg className="w-full h-full" viewBox="0 0 100 100" data-id="element-907">
              <circle cx="50" cy="50" r="45" fill="none" stroke="#1C2541" strokeWidth="6" data-id="element-908" />
              <motion.circle cx="50" cy="50" r="45" fill="none" stroke="url(#gradient)" strokeWidth="6" strokeLinecap="round" strokeDasharray="283" strokeDashoffset={283 - 283 * progress / 100} data-id="element-909" />
              {/* Small decorative circles */}
              {[0, 60, 120, 180, 240, 300].map((angle, i) => <motion.circle key={i} cx={50 + 45 * Math.cos(angle * Math.PI / 180)} cy={50 + 45 * Math.sin(angle * Math.PI / 180)} r="3" fill={progress >= (i + 1) * 16.6 ? '#19D3DA' : '#1C2541'} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              delay: i * 0.2
            }} data-id="element-910" />)}
              <defs data-id="element-911">
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-912">
                  <stop offset="0%" stopColor="#7D56F4" data-id="element-913" />
                  <stop offset="100%" stopColor="#19D3DA" data-id="element-914" />
                </linearGradient>
              </defs>
            </svg>
            {/* Center icon */}
            <motion.div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-4xl" animate={{
            rotate: [0, 360]
          }} transition={{
            duration: 20,
            ease: 'linear',
            repeat: Infinity
          }} data-id="element-915">
              🧬
            </motion.div>
            {/* Floating stars/particles */}
            {[...Array(6)].map((_, i) => <motion.div key={i} className="absolute text-xl" initial={{
            x: (Math.random() - 0.5) * 40,
            y: (Math.random() - 0.5) * 40,
            opacity: 0
          }} animate={{
            x: (Math.random() - 0.5) * 80,
            y: (Math.random() - 0.5) * 80,
            opacity: [0, 1, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            delay: i * 0.5
          }} style={{
            top: '50%',
            left: '50%'
          }} data-id="element-916">
                ✨
              </motion.div>)}
          </div>
          <h1 className="text-2xl font-bold mb-2" data-id="element-917">
            Mapping Your Career Genome
          </h1>
          <motion.div key={currentStage} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} className="h-8 mb-6" data-id="element-918">
            <p className="text-[#B8C0E0]" data-id="element-919">{stages[currentStage]}</p>
          </motion.div>
          <div className="bg-[#1C2541] rounded-full h-2 w-full mb-2" data-id="element-920">
            <motion.div className="h-2 bg-gradient-to-r from-[#7D56F4] to-[#19D3DA] rounded-full" style={{
            width: `${progress}%`
          }} data-id="element-921" />
          </div>
          <p className="text-sm text-[#B8C0E0]" data-id="element-922">{progress}% Complete</p>
        </motion.div>
      </div>
    </div>;
};